import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import * as Sentry from "@sentry/react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  OutlinedInput,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import { MdContentCopy } from "react-icons/md";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import CancelIcon from "@material-ui/icons/Cancel";
import queryString from "query-string";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL, PRICES_URL } from "../../services/configs";
import useResizer from "../../services/useResizer";
import Icon from "../../fontIcons/icon";
import { Info } from "@material-ui/icons";
import CryptoWithdrawDepositCard from "../../components/CryptoWithdrawDepositCard";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";

export default function CryptoWithdraw(props) {
  const classes = useStyles();
  let theme = useTheme();
  let history = useHistory();
  const isMobile = useResizer();

  const token = useSelector((state) => state.trading.TOKEN);
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);

  const statusDict = {
    FAILED: "REJECTED",
    IN_PROGRESS: "PENDING",
    AWAITING_ADMIN_ACTION: "PENDING",
    AWAITING_USER_VERIFICATION: "UNVERIFIED",
    APPROVED_BY_ADMIN: "SUCCESS",
    PROCESSED_BY_ADMIN: "SUCCESS",
    REJECTED_BY_ADMIN: "REJECTED",
  };

  const darkStatusColor = {
    SUCCESS: "#C1F4D8",
    FAILED: "#fed9d9",
    IN_PROGRESS: "#fefcd9",
    PENDING: "#fefcd9",
    AWAITING_ADMIN_ACTION: "#fefcd9",
    AWAITING_USER_VERIFICATION: "#fefcd9",
    APPROVED_BY_ADMIN: "#C1F4D8",
    PROCESSED_BY_ADMIN: "#C1F4D8",
    REJECTED_BY_ADMIN: "#fed9d9",
  };

  const darkStatusBackground = {
    SUCCESS: "#20581f",
    FAILED: "#581f1f",
    IN_PROGRESS: "#58571f",
    PENDING: "#58571f",
    AWAITING_ADMIN_ACTION: "#58571f",
    AWAITING_USER_VERIFICATION: "#58571f",
    APPROVED_BY_ADMIN: "#20581f",
    PROCESSED_BY_ADMIN: "#20581f",
    REJECTED_BY_ADMIN: "#581f1f",
  };

  const lightStatusColor = {
    SUCCESS: "#37a609",
    FAILED: "#ff5f5f",
    IN_PROGRESS: "#ffd95f",
    PENDING: "#ffd95f",
    AWAITING_ADMIN_ACTION: "#ffd95f",
    AWAITING_USER_VERIFICATION: "#ffd95f",
    APPROVED_BY_ADMIN: "#37a609",
    PROCESSED_BY_ADMIN: "#37a609",
    REJECTED_BY_ADMIN: "#ff5f5f",
  };

  // const [coinConfig, setCoinConfig] = useState(null);

  const [balance, setBalance] = useState(0);
  const [inOrder, setInOrder] = useState(0);
  const [openDialog, setDialog] = useState(false);

  const [address, setAddress] = useState(null);
  const [amount, setAmount] = useState(null);
  const [tagMemo, setTagMemo] = useState(null);
  const [verify, setVerify] = useState(false);
  const [transferId, setTransferId] = useState(null);
  const [otp, setOtp] = useState(null);
  const [cryptoTrans, setCryptoTrans] = useState(null);

  const [doubleClick, setDoubleClick] = useState(false);

  const [errorFields, setErrorFields] = useState({
    address: false,
    amt: false,
    otp: false,
  });

  const [counter, setCounter] = useState(120);
  const [startTimer, setStartTimer] = useState(false);

  const { handleClickAlert, refreshBalances, bannedTimeout } =
    useContext(CoinContext);

  const val = queryString.parse(props.location.search);

  const coinConfigData = useSelector((state) => state.trading.COIN_ICONS);
  const coinConfig = coinConfigData?.[val.coin];

  const handleDialogOpen = () => {
    setDialog(true);
  };

  const handleDialogClose = () => {
    setDialog(false);
  };

  // for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // useEffect(() => {
  //   fetcher(`/v1/coinConfig/${val.coin}`)
  //     .then((data) => {
  //       if (!data.status) {
  //         // setCoinConfig(data);
  //         // console.log(data);
  //       }
  //     })
  //     .catch((err) => {
  //       // console.error(err);
  //     });
  // }, [val.coin]);

  // get coin balance
  useEffect(() => {
    getCoinBalance();
  }, [val.coin, refreshBalances]);

  function getCoinBalance() {
    if (token) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/balances/${val.coin}`)
        .then((data) => {
          // console.log(data);
          if (data[0]) {
            setBalance(data[0].availableBalance);
            setInOrder(data[0].inOrderBalance);
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
    }
  }

  useEffect(() => {
    loadCryptoTrans();
  }, [val.coin, page, rowsPerPage]);

  function loadCryptoTrans() {
    if (token) {
      var bearer = "Bearer " + token;
      fetcher(
        `/v1/transfers/crypto?sortBy=createdAt&direction=DESC&page=${
          page + 1
        }&pageSize=${rowsPerPage}&searchId=${val.coin}`
      )
        .then((data) => {
          // console.log("Getting crypto transfers", data);
          if (!data.status) {
            setCryptoTrans(data);
          }
        })
        .catch((err) => {
          // console.error(err)
        });
    }
  }

  function withdrawAmt() {
    if (address && amount && coinConfig) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/balances/${val.coin}`)
        .then((data) => {
          // console.log(data);
          if (data[0]) {
            setBalance(data[0].availableBalance);
            setInOrder(data[0].inOrderBalance);

            if (
              amount >= coinConfig.minAmountWithdraw &&
              amount <= Number(data[0].availableBalance)
            ) {
              fetcher(`/v1/transfers/crypto`, {
                method: "POST",
                body: {
                  asset: val.coin,
                  amount: amount,
                  address: address,
                  memo: tagMemo ? (tagMemo === "0" ? "0-MANUAL" : tagMemo) : "",
                },
              })
                .then((data) => {
                  if (data[0]) {
                    setStartTimer(true);
                    handleClickAlert(
                      "warning",
                      `Enter email OTP to verify withdrawal request`
                    );
                    setErrorFields({
                      ...errorFields,
                      address: false,
                      amt: false,
                    });
                    if (data[0].id) {
                      setTransferId(data[0].id);
                      setVerify(true);
                    }
                  }
                  getCoinBalance();
                  loadCryptoTrans();
                  setDoubleClick(false);
                })
                .catch((err) => {
                  if (err?.info?.detail) {
                    const messageRes = err.info.detail;
                    const actualMessage = messageRes.substring(
                      messageRes.indexOf('"') + 1,
                      messageRes.length - 1
                    );
                    handleClickAlert(
                      "error",
                      `Request failed,${actualMessage}`
                    );
                  }
                  setTransferId(null);
                  setErrorFields({
                    ...errorFields,
                    address: false,
                    amt: false,
                  });
                });
            } else {
              if (amount > Number(data[0].availableBalance)) {
                handleClickAlert(
                  "error",
                  `Request failed, insufficient balance`
                );
              } else {
                setErrorFields({
                  ...errorFields,
                  amt: true,
                });
              }
              setDoubleClick(false);
            }
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
    } else {
      setErrorFields({
        ...errorFields,
        address: address ? false : true,
        amt: amount ? false : true,
      });
      setDoubleClick(false);
    }
  }

  function verifyWithdraw() {
    if (otp && transferId) {
      fetcher(`/v1/transfers/crypto/verify`, {
        method: "POST",
        body: {
          transferId: transferId,
          otp: otp,
        },
      })
        .then((res) => {
          handleClickAlert("success", `Request sent`);

          getCoinBalance();
          loadCryptoTrans();
          setAddress("");
          setAmount("");
          setTagMemo("");
          setOtp("");
          setVerify(false);
          setErrorFields({
            ...errorFields,
            otp: false,
          });
          setDoubleClick(false);
          setTransferId(null);
          // console.log("Verifying request");
        })
        .catch((err) => {
          if (err.status === 400) {
            handleClickAlert("error", `Request failed, incorrect otp.`);
          } else {
            handleClickAlert(
              "error",
              `Failed to send request, please try again`
            );
          }
          // console.error(err);
          setDoubleClick(false);
        });
    } else {
      setErrorFields({
        ...errorFields,
        otp: true,
      });
      setDoubleClick(false);
    }
  }

  function resendOtp() {
    if (transferId) {
      setStartTimer(true);
      fetcher(`/v1/transfers/resendOtp/${transferId}`, { method: "POST" })
        .then((res) => {
          handleClickAlert("success", "OTP resent");
        })
        .catch((err) => {
          handleClickAlert("error", "Failed to resend OTP");
          console.error(err);
          // console.error(err);
        });
    } else {
      handleClickAlert("error", "Failed to resend OTP");
    }
  }

  function cancelRequest(cancelId) {
    if (cancelId) {
      fetcher(`/v1/transfers/crypto/cancel/${cancelId}`, { method: "POST" })
        .then((res) => {
          handleClickAlert("success", "Request cancelled successfully.");
          getCoinBalance();
          loadCryptoTrans();
          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", "Failed to cancel request");
          console.error(err);
          // console.error(err);
        });
    } else {
      handleClickAlert("error", "Failed to cancel request");
    }
  }

  const padTime = (time) => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time) => {
    // Convert seconds into minutes and take the whole part
    const minutes = Math.floor(time / 60);

    // Get the seconds left after converting minutes
    const seconds = time % 60;

    //Return combined values as string in format mm:ss
    return `${minutes}:${padTime(seconds)}`;
  };

  useEffect(() => {
    let timer;
    if (counter > 0 && startTimer) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    } else if (counter === 0) {
      setStartTimer(false);
      setCounter(120);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter, startTimer]);

  return (
    <div className={classes.container}>
      <h1 className="mb-3">Withdraw {val.coin}</h1>
      <p className="font-light mb-5">
        <span
          className="underline cursor-pointer"
          onClick={() => {
            history.push("/wallet/crypto");
          }}
        >
          Crypto Wallet
        </span>
        {" > "}
        <span style={{ color: "#3AC4AB" }}>Withdraw</span>
      </p>

      {/* single card view */}
      <div className="dark:bg-[#141828] bg-[#eee] p-5 rounded-md">
        <div className={`${classes.flexContainer} mb-3`}>
          <img
            src={coinIcons[val.coin]?.activeIconUrl}
            height="auto"
            width={30}
            className="mr-2"
            alt={props.coin}
          />
          <p
            style={{
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            {val.coin} Wallet Balance
          </p>
        </div>
        <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
          <div className="w-full flex items-center">
            <p className={`${classes.ptitle} text-sm`}>Available</p>
            <p className={classes.pvalue}>
              {Number(balance)} {val.coin}{" "}
            </p>
          </div>{" "}
        </div>
        <div className={classes.flexContainer}>
          <div
            className="flex whitespace-nowrap items-center w-full"
            style={{ marginTop: "5px" }}
          >
            <p className={`${classes.ptitle} text-sm`}>In Order</p>
            <p className={classes.pvalue}>
              {Number(inOrder)} {val.coin}
            </p>
          </div>
        </div>
        <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
          <p className={`${classes.ptitle} text-sm`}>Total</p>
          <p className={classes.pvalue}>
            {Number(balance) + Number(inOrder)} {val.coin}
          </p>
        </div>
      </div>

      <div>
        <div className={classes.subContainer}>
          <div className={classes.notice}>
            <div className={`${classes.flexContainer} mb-3 `}>
              <BsExclamationCircle
                style={{ fontSize: "20px", color: "#3AC4AB" }}
              />
              <p
                style={{
                  color: "#3AC4AB",
                  fontWeight: "bold",
                  marginLeft: "15px",
                }}
              >
                Please Note
              </p>
            </div>
            <ol className="ml-5">
              <li>
                <p>
                  Do not withdraw directly to a crowdfund or ICO address, as
                  your account will not be credited with tokens from such sales.
                </p>
              </li>
              <li>
                <p>
                  Always verify the address, PocketBits cannot refund any
                  incorrect transfers.
                </p>
              </li>
              <li>
                <p>
                  Once you have submitted your request, enter OTP sent to your
                  email to verify the request.
                </p>
              </li>
              <li>
                <p>
                  After verification you can track the progress in the
                  transaction history page.
                </p>
              </li>
              <li>
                <p>
                  Unverified Crypto Withdrawals are automatically cancelled
                  after 10 mins and the balance is credited back to the wallet.
                </p>
              </li>
              {coinConfig ? (
                coinConfig.tagOrMemo ? (
                  <li>
                    <p>
                      When withdrawing to a personal wallet use TAG/MEMO as 0
                    </p>
                  </li>
                ) : null
              ) : null}
            </ol>
          </div>
        </div>
        <div className={classes.subContainer}>
          <div className={classes.flexContainer}>
            <AccountBalanceWalletIcon
              style={{ fontSize: "20px", color: "#3AC4AB" }}
            />
            <p
              style={{
                color: "#3AC4AB",
                fontSize: "16px",
                fontWeight: "bold",
                marginLeft: "15px",
              }}
            >
              Wallet Details
            </p>
          </div>
          <div className={classes.notice} style={{ marginTop: "16px" }}>
            Minimum withdrawal is{" "}
            <span className="font-bold">
              {coinConfig ? coinConfig.minAmountWithdraw : ""} {val.coin}
            </span>
          </div>
          <div
            style={{
              marginTop: "24px",
            }}
          >
            <p className="mb-3">{val.coin} Wallet Address</p>
            <Box mb={3}>
              <TextField
                id="wallet-address"
                fullWidth={true}
                variant="outlined"
                placeholder={"Enter your " + val.coin + " Wallet Address"}
                onChange={(e) => {
                  let val = e.target.value.replace(/\s/g, "");
                  setAddress(val);
                }}
                value={address}
                error={errorFields.address}
                helperText={
                  errorFields.address ? "Please enter the wallet address" : null
                }
                spellCheck="false"
                onKeyUp={(event) => {
                  if (event.key === "Enter" || event.key === "NumpadEnter") {
                    withdrawAmt();
                  }
                }}
                disabled={verify}
              />
            </Box>
            {coinConfig ? (
              coinConfig.tagOrMemo ? (
                <>
                  <p style={{ marginTop: "30px" }} className="mb-3">
                    {val.coin} Withdrawal Memo
                  </p>
                  <Box mb={3}>
                    <TextField
                      placeholder={"Enter Withdrawal Memo"}
                      id="memo-tag"
                      fullWidth={true}
                      variant="outlined"
                      onChange={(e) => {
                        setTagMemo(e.target.value);
                      }}
                      value={tagMemo}
                      disabled={verify}
                    />
                  </Box>
                </>
              ) : null
            ) : null}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <p className="mb-3">Amount</p>
            </div>{" "}
            <div className="flex w-full mb-3">
              <Box width={250}>
                <TextField
                  fullWidth
                  placeholder={"Enter Amount"}
                  id="amount"
                  fullWidth={true}
                  variant="outlined"
                  // type="number"
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^0-9.]*$/, "");
                    setAmount(val);
                  }}
                  value={amount}
                  error={errorFields.amt}
                  helperText={
                    errorFields.amt
                      ? "Please make sure the amount entered is above minimum withdrawal amount"
                      : null
                  }
                  onKeyUp={(event) => {
                    if (event.key === "Enter" || event.key === "NumpadEnter") {
                      withdrawAmt();
                    }
                  }}
                  disabled={verify}
                />
              </Box>

              <Button
                className="ml-3 whitespace-nowrap"
                variant="outlined"
                disabled={doubleClick}
                color="primary"
                onClick={() => {
                  setAmount(balance);
                }}
              >
                Send All
              </Button>
            </div>
            <div className="mb-4 flex items-center">
              {/* <Info className="mr-2" style={{ width: "20px" }}></Info> */}
              <span className="mr-2">Fee:</span>
              <span>
                {coinConfig ? coinConfig.withdrawFee : "0"} {val.coin}
              </span>
              <div>
                <span className={classes.link} onClick={handleDialogOpen}>
                  {" "}
                  Help?
                </span>
              </div>
            </div>
            {verify ? (
              <>
                <p style={{ margin: 0 }} className={classes.fieldLabel}>
                  Email OTP
                </p>
                <Box>
                  <TextField
                    id="otp"
                    fullWidth={true}
                    variant="outlined"
                    // type="number"
                    onChange={(e) => {
                      let val = e.target.value.replace(/[^0-9.]*$/, "");
                      setOtp(val);
                    }}
                    value={otp}
                    error={errorFields.otp}
                    helperText={errorFields.otp ? "Please enter otp" : null}
                    onKeyUp={(event) => {
                      if (
                        event.key === "Enter" ||
                        event.key === "NumpadEnter"
                      ) {
                        verifyWithdraw();
                      }
                    }}
                  />
                </Box>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "24px",
                    marginTop: "5px",
                  }}
                >
                  {counter === 0 || counter === 120 ? (
                    <p onClick={resendOtp} className={classes.link}>
                      Resend OTP
                    </p>
                  ) : (
                    <div>Resend OTP in {format(counter)}</div>
                  )}
                </div>
              </>
            ) : null}
            <Divider />
            <Box
              display="flex"
              justifyContent="space-between"
              style={{
                marginTop: "12px",
                marginBottom: "8px",
                marginLeft: "12px",
                marginRight: "12px",
              }}
            >
              <div>
                <p style={{ fontSize: "14px", color: "#9fa1a0" }}>
                  You will receive
                </p>
                <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {amount && coinConfig
                    ? (amount - coinConfig.withdrawFee).toFixed(
                        coinConfig.decimalWithdraw
                      )
                    : 0}{" "}
                  {val.coin}
                </p>
              </div>
            </Box>
            <Button
              variant="contained"
              disableElevation
              disabled={doubleClick}
              color="primary"
              style={{
                width: isMobile ? "100%" : "25%",
                height: "40px",
                marginTop: "8px",
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "6px",
              }}
              onClick={() => {
                setDoubleClick(true);
                if (verify) {
                  verifyWithdraw();
                } else {
                  withdrawAmt();
                }
              }}
            >
              {verify ? "Verify" : "Withdraw"}
            </Button>
          </div>
        </div>
        <Divider />
        <div className={classes.subContainer}>
          <div className={classes.flexContainer}>
            <ImportExportIcon style={{ fontSize: "20px", color: "#3AC4AB" }} />
            <p
              style={{
                color: "#3AC4AB",
                fontSize: "16px",
                fontWeight: "bold",
                marginLeft: "4px",
              }}
            >
              {val.coin} Transactions
            </p>
          </div>
          <div className="mt-5">
            {!Boolean(cryptoTrans?.content?.length) ? (
              <h3 className="font-light text-gray-800 dark:text-gray-400 ml-6">
                No Transactions found
              </h3>
            ) : (
              cryptoTrans?.content?.map((row) => (
                <CryptoWithdrawDepositCard
                  coinConfig={coinConfig}
                  // coinIcons={coinIcons[row.currency]}
                  data={row}
                ></CryptoWithdrawDepositCard>
              ))
            )}
          </div>
          {Boolean(cryptoTrans?.content?.length) && (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={cryptoTrans ? cryptoTrans.totalElements : 10}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage="Rows"
            />
          )}
        </div>

        <Dialog
          open={openDialog}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Network Fee Note"}
          </DialogTitle>
          <Divider />
          <DialogContent style={{ marginTop: "15px" }}>
            <DialogContentText id="alert-dialog-description">
              There is a small network fee for sending a {val.coin} transaction
              <br />
              <br />
              The transaction fee is updated periodically based on {
                val.coin
              }{" "}
              network activity in order to acheive reasonable transaction
              confirmation times.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleDialogClose}
              variant="contained"
              color="primary"
              style={{
                marginRight: "10px",
                marginBottom: "10px",
                color: "white",
                fontWeight: "bold",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    // [theme.breakpoints.down("sm")]: {
    //   minWidth: "450px",
    //   maxWidth: "450px",
    // },
    [theme.breakpoints.up("md")]: {
      width: "84%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    marginTop: "20px",
    paddingTop: "3px",
  },
  subContainer: {
    marginTop: "15px",

    paddingBottom: "15px",
    // marginLeft: "20px",
    // marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  ptitle: {
    width: "33%",
    color: "#9fa1a0",
    marginRight: "8px",
    fontSize: "17px",
  },
  pvalue: {
    fontSize: "15px",
    fontWeight: "bold",
    color: "#92989B",
  },
  fieldLabel: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    opacity: "0.5",
    textTransform: "uppercase",
    marginTop: "17px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
  },
  notice: {
    border: `1px solid #3AC4AB`,
    backgroundColor: "rgba(86,195,164,0.1)",
    padding: "15px",
    // marginTop: "20px",
    // marginLeft: "15px",
    // marginRight: "15px",
    borderRadius: "8px",
  },
  // container: {
  //   flexGrow: 1,
  //   [theme.breakpoints.down("sm")]: {
  //     minWidth: "450px",
  //     maxWidth: "450px",
  //   },
  // },
  backLink: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
    marginBottom: 0,
  },
  headerCell: {
    background: theme.palette.type === "dark" ? "#151827" : "white",
    fontWeight: "bold",
  },
  table: {
    marginTop: "20px",
  },
}));
